import * as React from "react"
import 'bootstrap/dist/css/bootstrap.css'
import "primeicons/primeicons.css"
import "primereact/resources/themes/lara-light-cyan/theme.css"
import "./src/styles/global.css"
import 'aos/dist/aos.css';
import ScrollSlider from "./src/components/global/ScrollSlider"
import Layout from "./src/components/global/Layout"

// IMPORTANT:
// AuthProvider is dynamically imported so MSAL is NOT included
// in the initial JavaScript bundle of public pages.
const LazyAuthProvider = React.lazy(() =>
    import("./src/auth/AuthProvider").then((module) => ({
        default: module.AuthProvider,
    }))
)

export const wrapPageElement = ({ element, props }) => {
    const pathname = props?.location?.pathname || (typeof window !== "undefined" ? window.location.pathname : "")
    const isAdminPage = pathname.startsWith("/admin")
    // Admin pages need Microsoft authentication.
    // Load AuthProvider/MSAL only when an admin page is opened.
    if (isAdminPage) {
        return (
            <React.Suspense fallback={null}>
                <LazyAuthProvider>
                    {element}
                </LazyAuthProvider>
            </React.Suspense>
        )
    }

    // Public website does not need MSAL/authentication.
    return (
        <>
            <ScrollSlider />
            <Layout {...props}>
                {element}
            </Layout>
        </>
    )
}
